import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/css/style.css";
import { setToastDefaultOptions } from "vant";
import VueLazyload from "vue-lazyload";
import "lib-flexible/flexible";
import VConsole from "vconsole";
import "vant/es/toast/style";

// 在开发环境和测试环境下初始化 VConsole
if (process.env.VUE_APP_MODE === "preview" || process.env.VUE_APP_MODE === "development") {
  new VConsole();
}

const app = createApp(App);

setToastDefaultOptions({
  duration: 1000,
});

app.use(router);
app.use(VueLazyload, {
  filter: {
    webp(listener, options) {
      if (!options.supportWebp || process.env.VUE_APP_MODE === "development") return;
      if (/!q80$/g.test(listener.src)) {
        listener.src = listener.src.replace("!q80", "!webp");
      } else if (
        !/!q80/g.test(listener.src) &&
        !/^data:image\/png;base64/g.test(listener.src) &&
        /p.ppq666.cn/g.test(listener.src)
      ) {
        listener.src += "!webp";
        return false;
      }
    },
  },
});

app.mount("#app");
